<template>
  <div>
    <h1
      class="kbx-title"
      klickbox-edit-item="title"
      :klickbox-edit-label="$t('edit.canvas.question_title')"
      :style="stepStyle('title')">
      <text-editor
        v-if="!stepPreview.isGeneral"
        :content="stepPreview.title"
        :change="onChange"
        :toolbar="true"
        :placeholder="$t('edit.canvas.question_title_placeholder')"></text-editor>
      <span v-else>{{stepPreview.title}}</span>
    </h1>
  </div>
</template>

<script>
import TextEditor from 'src/components/general/TextEditor/Main';
import { mapGetters } from 'vuex';

export default {
  components: {
    TextEditor,
  },
  computed: mapGetters({
    quizStyle: 'quizStyle',
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: {
    onChange(text) {
      this.$store.dispatch('stepUpdateTitle', {
        event: { target: { value: text } },
        id: this.stepPreview.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Title.vue?33fa45ad
 **/